import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { DateTime } from 'luxon';
import _, { get as _get } from 'lodash';

import { withRouter } from 'react-router-dom';
import * as ODCalls from '../../../store/calls/indicativeOptionData';
import {
	addErrorAlert,
	toggleGlobalLoader,
} from '../../../store/calls/alertLoadingDispatch';
import { pullUserProjects, deactivateProject } from '../../../store/calls';

import * as actions from '../../../store/actions';
import ConfirmModal from '../../theme/modals/ConfirmModal';
import FormFlowWrapper from '../../theme/wrappers/FormFlowWrapper';
import AddressSearchModal from '../../subcomponents/dashboard/AddressSearchModal';
import api from "../../../store/api";
import LoginModal from "../../subcomponents/auth/LoginModal";

class MyProjects extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			isopenFilter: false,
			filterSelected: 0,
			textFilter: 0,
			query: '',
			currentData: [],
			typeDisplay: 'Projects',
			addressSearchModalVisible: false,
			showLoginModal: false,
			projectTypeFilter: 'ALL',
		};
	}

	componentDidMount() {
		toggleGlobalLoader(true);

		Promise.allSettled([
			ODCalls.getAssetTypes(),
			ODCalls.getBusinessTypes(),
			ODCalls.getAvailableImprovements(),
			api.get('/my-projects/').then((res) => {
				let {data} = res
				if (!Array.isArray(data)) res = [];
				this.setState({ data, currentData: data }, this.applyFilters);
				this.onSelectFilter(0);
			}),
		])
			.catch(() => {
				addErrorAlert('Failed to load all initial data.', 10 * 1000);
			})
			.finally(() => {
				toggleGlobalLoader(false);
			});
	}

	getImprovementName = (id) => {
		const { improvements } = this.props.optionData;
		if (!improvements || improvements.length == 0) return '';
		const improvement = improvements.find((i) => i.id == id);
		return improvement ? improvement.name : '';
	};

	getBusinessTypeName = (id) => {
		const { businessTypes } = this.props.optionData;
		if (!businessTypes || businessTypes.length == 0) return '';
		const businessType = businessTypes.find((i) => i.id == id);
		return businessType ? businessType.name : '';
	};

	onOpenFilter = (value) => {
		this.setState({
			isopenFilter: value != undefined ? value : !this.state.isopenFilter,
		});
	};

	onSelectFilter = (value) => {
		this.setState({
			filterSelected: value,
		});
		this.setState({
			isopenFilter: false,
		});
		switch (value) {
			case 0:
				this.filterData('modified', 'desc');
				break;
			case 1:
				this.filterData('data.project_name', 'asc');
				break;
			default:
		}
	};

	filterData = (orderbyfield = 'data.modified', typeOrder = 'desc') => {
		const { data } = this.state;
		const newDataArray = _.orderBy(data, orderbyfield, typeOrder);
		this.setState({ currentData: newDataArray });
	};

	getFilterSelectedName = () => {
		switch (this.state.filterSelected) {
			case 0:
				return 'Modified';
				break;
			case 1:
				return 'Name';
				break;
			default:
				return '';
		}
	};

	onOpenProject = (project, estimateGroupList) => {
		this.props.setFocusedProject(project.id);

		const formFlowComputed = {
			address: project.data.address,
			programs: project.data.programs,
		};

		this.props.clearFormFlow();
		this.props.updateInputs({ ...project.data, id: project.id });
		this.props.updateComputed(formFlowComputed);
		this.props.setFormFlowCurrStep(1);

		if (estimateGroupList && estimateGroupList.length > 0) {
			return this.props.history.push(`/project-estimate/${project.id}`);
		}
		this.props.history.push({
			pathname: '/project',
		});
	};

	onSearch = (e) => {
		if (e) e.preventDefault();
		let { query, data } = this.state;
		query = _.lowerCase(query);
		const newFilteredData = data.filter((x) => {
			return (
				_.lowerCase(_.get(x.data, 'project_name', '')).includes(query) ||
				_.lowerCase(_.get(x.data, 'address.formatted_address', '')).includes(
					query
				)
			);
		});
		this.setState({ currentData: newFilteredData });
	};

	renderTypeFilter() {
		const { projectTypeFilter } = this.state;
	  
		return (
		  <div className="field mr-3 mb-0">
			<div className="control">
			  <div className="select is-medium">
				<select
				  value={projectTypeFilter}
				  onChange={(e) =>
					this.setState(
					  { projectTypeFilter: e.target.value },
					  this.applyFilters
					)
				  }
				>
				  <option value="ALL">All</option>
				  <option value="Commercial">Commercial</option>
				  <option value="Residential">Residential</option>
				</select>
			  </div>
			</div>
		  </div>
		);
	  }
	
	  applyFilters = () => {
		const { data, query, projectTypeFilter } = this.state;
	  
		let filtered = [...data];
	  
		if (query) {
		  const q = _.lowerCase(query);
		  filtered = filtered.filter((x) =>
			_.lowerCase(_.get(x.data, 'project_name', '')).includes(q) ||
			_.lowerCase(_.get(x.data, 'address.formatted_address', '')).includes(q)
		  );
		}
	  
		if (projectTypeFilter !== 'ALL') {
		  filtered = filtered.filter(
			(p) =>
			  _.lowerCase(p.type_of_project) ===
			  _.lowerCase(projectTypeFilter)
		  );
		}
	  
		this.setState({ currentData: filtered });
	  };

	renderFilter() {
		const { isopenFilter, filterSelected } = this.state;

		return (
			<div
				className={
					isopenFilter
						? 'dropdown full-width-mobile is-active'
						: 'full-width-mobile dropdown mb-1'
				}
				onMouseLeave={() => this.onOpenFilter(false)}
			>
				<div
					className="dropdown-trigger full-width-mobile"
					onClick={this.onOpenFilter}
				>
					<button
						className="button is-medium full-width-mobile"
						aria-haspopup="true"
						aria-controls="dropdown-menu"
					>
						<span>Sort by: {this.getFilterSelectedName()}</span>
						<span className="icon is-small">
							<i className="fas fa-angle-down" aria-hidden="true" />
						</span>
					</button>
				</div>
				<div
					className="dropdown-menu is-medium full-width-mobile"
					id="dropdown-menu"
					role="menu"
				>
					<div className="dropdown-content">
						<a
							href="#"
							className={
								filterSelected == 0
									? 'dropdown-item is-active'
									: 'dropdown-item'
							}
							onClick={() => this.onSelectFilter(0)}
						>
							Modified
						</a>
						<a
							href="#"
							className={
								filterSelected == 1
									? 'dropdown-item is-active'
									: 'dropdown-item'
							}
							onClick={() => this.onSelectFilter(1)}
						>
							Name
						</a>
					</div>
				</div>
			</div>
		);
	}

	renderSearch() {
		return (
			<form className="field has-addons  full-width-mobile is-align-items-center mb-1">
				{/* {this.state.query !== "" && ( */}
				{/*  <span */}
				{/*    className=" has-text-link is-size-7 mr-3 btn-clear" */}
				{/*    onClick={() => */}
				{/*      this.setState({ currentData: this.state.data, query: "" }) */}
				{/*    } */}
				{/*  > */}
				{/*    Clear */}
				{/*  </span> */}
				{/* )} */}

				<div className="control full-width">
				<input
					className="input is-medium"
					type="text"
					placeholder="Search"
					value={this.state.query}
					onChange={(e) => {
						this.setState(
						{ query: e.target.value },
						this.applyFilters
						);
					}}
					/>
				</div>
			</form>
		);
	}

	renderItem = (project) => {
		if (!project) return <></>;
		const { modified, data, estimate_groups, applications, shared_permissions } = project;
		const { address, project_name, improvements } = data || {};

		if (!address) return <></>;
		const modifiedFormatted = DateTime.fromJSDate(new Date(modified)).toFormat(
			'D'
		);
		return (
			<div
				key={project.id + 'key-projects'}
				className="box box-my-project is-flex is-flex-direction-column flex-start"
			>
				<div className="is-flex is-justify-content-space-between ">
					<div />
					<span>{modifiedFormatted}</span>
				</div>

				<p
					className={`user-title has-text-weight-semibold ${
						project?.type_of_project === "Commercial"
						? "has-text-primary"
						: "has-text-success"
					}`}
					>
					{project?.type_of_project}
				</p>

				<h3>
					<b>{project_name}</b>
				</h3>
				<p>{address && address.formatted_address}</p>
				<div className="mt-4">
					{improvements &&
						improvements.length > 0 &&
						improvements.map((impr) => (
							<h6 className=" is-6 mb-0 improvements-items user-title has-text-justified">
								<span>{this.getImprovementName(impr.id)}:</span>
								<span className="has-text-weight-semibold">
									{impr.value ? ` $${impr.value}` : ` -`}
								</span>
							</h6>
						))}
				</div>
				<hr />
				<div className="columns is-align-items-center">
					{/* <div className={'column'}> */}
					{/*  <div className={'is-flex is-justify-content-flex-start'}> */}
					{/*   */}
					{/*  </div> */}
					{/* </div> */}
					<div className="column">
						<div className="is-flex is-justify-content-flex-start">
							{(shared_permissions || []).length ?
								<div className="">
									Shared Permissions: {shared_permissions.map((p) => p).join(', ')}
								</div> :
								<div className="is-italic" />
							}
						</div>
					</div>
					<div className="column">
						<div className="buttons is-right">
							{estimate_groups && estimate_groups.length > 0 ? (
								<>
									{applications && applications.length ? (
										<div className="">
											<button
												className="button full-width-mobile is-link "
												onClick={() =>
													this.props.history.push(
														`/application/${applications[0]}`
													)
												}
											>
												View Application
											</button>
										</div>
									) : (
										<div className="">
											<button
												className="button full-width-mobile is-link"
												onClick={() =>
													this.onOpenProject(project, estimate_groups)
												}
											>
												Get Today's Financing Options
											</button>
										</div>
									)}
									<div className="">
										<button
											className="button full-width-mobile is-primary"
											onClick={() => this.onOpenProject(project)}
										>
											{/* <i className="fa fa-edit mr-2"></i> */}
											Edit
										</button>
									</div>
								</>
							) : (
								<div className="">
									<button
										className="button is-primary"
										onClick={() => this.onOpenProject(project)}
									>
										Finish Project
									</button>
								</div>
							)}

							<div>
								<button
									className="button full-width-mobile"
									onClick={() => {
										this.setState({
											confirmRemoval: true,
											confirmRemovalPrompt: `Are you sure you want delete the 
                                                  ${
																										applications &&
																										applications.length
																											? 'application for'
																											: 'project'
																									} "${project_name}"?`,
											confirmRemovalID: project.id,
										});
									}}
								>
									<div className="has-text-danger">
										{/* <i className={'fas fa-trash mr-3'}/> */}
										Delete
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	};

	render() {
		const { currentData, query } = this.state;
		return (
			<FormFlowWrapper controlWidth>


				<div className="tabs is-boxed my-5 pb-2 no-print">
					<ul>
						{['Projects', 'Applications', "Bid Desk Projects"].map((d) => (
							<li
								className={
									this.state.typeDisplay === d
										? 'is-active has-text-weight-semibold has-background-white-bis-transparent '
										: 'has-text-primary'
								}
							>
								<a
									onClick={() => this.setState({ typeDisplay: d })}
									className="is-size-4"
								>
									My {d}
								</a>
							</li>
						))}
					</ul>
				</div>
				<div className="container px-2">
					{/* <h1 className="is-size-4 has-text-primary mt-4  mb-4 has-text-weight-semibold  default-title "> */}
					{/*  My Projects */}
					{/* </h1> */}
                  <div className="is-flex is-justify-content-space-between is-flex-wrap-wrap my-4">
                    <div className="is-flex">
                      <button className="button is-medium mr-3 is-link"
                              onClick={() => this.setState({addressSearchModalVisible: true})}>
                        <i className="fas fa-plus-circle mr-3"/> <span>New Project</span>
                      </button>
                      {this.renderTypeFilter()}
					  {this.renderFilter()}
                    </div>
                    {this.renderSearch()}

                  </div>

					<div>
						{/* PROJECTS WITH APPLICATIONS */}
						{currentData &&
							this.state.typeDisplay === 'Applications' &&
							currentData
								.filter((d) => !!d.applications.length && !d.is_biddesk && !d.is_biddesk_application)
								.map((project) => this.renderItem(project))}

						{/* PROJECTS WITHOUT APPLICATIONS */}
						{currentData &&
							this.state.typeDisplay === 'Projects' &&
							currentData
								.filter((d) => !d.applications.length)
								.map((project) => this.renderItem(project))}
						
						{/* PROJECTS BIDDESK */}
						{currentData &&
							this.state.typeDisplay === 'Bid Desk Projects' &&
							currentData
								.filter((d) => d.is_biddesk || d.is_biddesk_application)
								.map((project) => this.renderItem(project))}

						{/* NO RESULTS */}

						{query != '' && currentData.length == 0 && (
							<p className=" has-text-centered">0 results.</p>
						)}

						{/* NO PROJECTS */}
						{query == '' && currentData.length == 0 && (
							<p className=" is-size-4 has-text-centered my-6">No projects yet!</p>
						)}


					</div>
				</div>

				<ConfirmModal
					type="warning"
					visible={this.state.confirmRemoval}
					prompt={this.state.confirmRemovalPrompt}
					onAccept={() => {
						deactivateProject(this.state.confirmRemovalID).then(() => {
							this.setState({
								confirmRemoval: false,
								confirmRemovalPrompt: null,
								confirmRemovalID: null,
								currentData: this.state.currentData.filter(
									(d) => d.id !== this.state.confirmRemovalID
								),
								data: this.state.data.filter(
									(d) => d.id !== this.state.confirmRemovalID
								),
							});
						});
					}}
				/>

              {this.state.addressSearchModalVisible &&
                  <AddressSearchModal
                      onClose={() => this.setState({ addressSearchModalVisible: false })}
                  />
              }
			  
			</FormFlowWrapper>
		);
	}
}

const mapStateToProps = (state) => ({
	optionData: state.indicativeOptionData,
	tokenData: state.user.decodedTokenData,
});

const mapDispatchToProps = (dispatch) => ({
	// focused project is alwasy ust the id
	setFocusedProject: (data) =>
		dispatch(actions.projectLeads.setFocusedProject(data)),
	updateInfoFeedDisplay: (data) =>
		dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
	clearInfoFeedDisplay: (data) =>
		dispatch(actions.infoFeed.clearInfoFeedDisplay(data)),

	updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
	updateComputed: (data) =>
		dispatch(actions.formFlow.updateFormFlowComputed(data)),
	setFormFlowCurrStep: (data) =>
		dispatch(actions.formFlow.setFormFlowCurrStep(data)),
	clearFormFlow: (data) => dispatch(actions.formFlow.clearFormFlow(data)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(MyProjects));
